import React, { Component } from "react";
import { OpacityRange } from "../../../../.common/OpacityRange/OpactiyRange";
import { LayerModuleFactory } from "../../../../../modules/LayerModules/.LayerModuleFactory";
import { Loading } from "../../../../.common/Loading/Loading";
import { LayoutContext } from '../../../../../modules/ContextModules/LayoutContext';

import './LayerItem.css'

import commonImg from './.image/layer.png'
import folderImg from './.image/folder.png'
import backgroundImg from './.image/矩形 51@3x.png'
import { LocateButton } from "../../../../.common/Buttons/Locate/LocateButton";
//import { RemoveButton } from "../../../../.common/Buttons/Remove/RemoveButton";

export class LayerItem extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);
        this.layerModule = null;
        this.coreLayer = null;

        this.state = {
            isOpenedCoreLayers: false
        };
    }

    componentDidMount() {
        this.layerModule = LayerModuleFactory.CreateLayer(window.gMainMap.TerrainView, this.props.data);
        this.layerModule.OpenLayer(this.openCallback);
    }

    componentWillUnmount() {
        this.handleRemove();
    }

    render() {
        return (
            <div className="layerItem">
                <img src={backgroundImg} style={{ position: 'absolute', zIndex: '-999', height: '100%', width: '100%' }} alt="圖層項目_背景" />
                {/* 圖層標頭 */}
                <div className="layerItem__header">
                    <div style={{ lineHeight: '30px' }}>
                        <img src={this.imgWithType()} width={24} height={24} alt="圖層項目_圖示" />
                    </div>
                    <span title={this.props.data.Name}>{this.props.data.Name}</span>
                    <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'end' }}>
                        <div style={{ display: 'inline-flex', position: 'relative', margin: 'auto 0' }}>
                            {
                                this.state.isOpenedCoreLayers ?
                                    <LocateButton width={24} height={24} onClick={this.handleLocate} /> :
                                    <Loading width={24} height={24} />
                            }
                            {/*<RemoveButton width={24} height={24} onClick={this.handleRemove} />*/}
                        </div>
                    </div>
                    {/* {
                        this.state.isOpenedCoreLayers ?
                        <div style={{display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'end'}}>
                            <div style={{display: 'inline-flex', position: 'relative', margin: 'auto 0'}}>
                                <Loading width={24} height={24}/>
                                <LocateButton width={24} height={24} onClick={this.handleLocate}/>
                                <RemoveButton width={24} height={24} onClick={this.handleRemove}/>
                            </div>   
                        </div>                         
                        : 
                    }                   */}

                </div>
                {/* 透明度拉條 */}
                {
                    this.state.isOpenedCoreLayers && this.props.data.ID !== "pipeline" && !this.props.data.Name.includes("3DTiles") ?
                        <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                            <OpacityRange handleChangeValue={this.handleChangeOpacityValue} />
                        </div>
                        : null
                }

            </div>
        );
    }

    imgWithType() {
        switch (this.props.data.Class) {
            case "FOLDER":
                return folderImg;
            default:
                return commonImg;
        }
    }

    openCallback = (param) => {
        const { socioeconomicContext } = this.context;
        const { readilyAvailableHouseToolContext } = this.context;
        this.setState({
            isOpenedCoreLayers: param.success
        });

        this.coreLayer = this.layerModule.oviewLayer;
        if (param.ID && param.ID === "南投市近似化建物") {
            readilyAvailableHouseToolContext.set(this.coreLayer);
            this.coreLayer.setOnClickEntity(this.addBuildOnClickEntity.bind(this));
        }

        if (param.ID && param.ID.includes("3D社會經濟地圖")) {
            if (socioeconomicContext.layerModule) {
                socioeconomicContext.layerModule.RemoveLayer();
                this.props.handleRemove([socioeconomicContext.layerModule.layerInfo.Name]);
            }
            socioeconomicContext.update({ layerModule: this.layerModule });
            socioeconomicContext.remove();

            this.context
                .draggableWindowContext["socioeconomic"]
                .update({
                    isOpened: true,
                    isMinimized: false
                });
        }
    }

    //建物模型點擊事件
    addBuildOnClickEntity(id, pos) {
        const { LayerAttrsRndContext } = this.context;
        const { readilyAvailableHouseToolContext } = this.context;
        const { draggableWindowContext } = this.context;
        this.coreLayer.getColAndAttrs(id, function (attrs) {
            let obj = {};
            for (let i = 1; i < attrs.ATTR.length; i++) {
                let col = LayerAttrsRndContext.attrsMaps[0][attrs.COL[i]];
                obj[col] = attrs.ATTR[i];
            }

            LayerAttrsRndContext.update({
                isShowLayerAttrsRnd: true,
                layerAttrsRnd: obj,
                layerAttrsRndTitle: attrs.ATTR[2] + ":" + attrs.ATTR[0],
                layerAttrsRndPosition: { x: pos.x, y: pos.y }
            });
        });
        this.coreLayer.resetAllOpacityEntityID();
        this.coreLayer.resetAllHideEntityID();
        this.coreLayer.removeBuildingFloorColor(id);
        if (draggableWindowContext.readilyAvailableHouseTool.isOpened) {
            this.coreLayer.setOpacityByEntityID(id, 0.7);
            this.coreLayer.setHideByEntityID(id, window.ov.HIDE.DISABLE_SELECT);
            readilyAvailableHouseToolContext.setID(id);
        }
    }

    handleChangeOpacityValue = (event) => {
        this.layerModule.SetOpacity(Number(event.currentTarget.value) / 100);
        if (this.props.data.ID.includes("社會經濟") && this.props.data.Name.includes("3D")) {
            this.coreLayer.entities.forEach(entity => {
                entity.update({ opacity: Number(event.currentTarget.value) / 100 });
            })
        }
    }

    handleLocate = () => {
        this.layerModule.Goto();
    }

    handleRemove = () => {
        const { socioeconomicContext } = this.context;
        const { readilyAvailableHouseToolContext } = this.context;
        console.log(this.props.data.Name);

        if (this.props.data.ID === "南投市近似化建物") {
            readilyAvailableHouseToolContext.remove();
        }

        if (this.props.data.ID.includes("社會經濟") && this.props.data.Name.includes("3D")) {
            socioeconomicContext.update({ isEmptyModule: true });
            socioeconomicContext.remove();

            this.context
                .draggableWindowContext["socioeconomic"]
                .update({
                    isOpened: false,
                    isMinimized: false
                });
        }
        this.layerModule.RemoveLayer();
        this.props.handleRemove([this.props.data.Name]);
    }
}
